import parse from 'html-react-parser';

import _ from "underscore";
import * as XLSX from "xlsx";

import APPConfig from "./appConfig";
// import Lookup from "../helpers/lookup";

import {
  faFileAlt,
  faFileExcel,
  faFileWord,
  faFileArchive,
  faFileCsv,
  faFilePdf,
  faPaperclip,
} from "@fortawesome/free-solid-svg-icons";

// Constants
import { LOGINPAGE, UNAUTHRIZEDPAGE, SIGNOUTPAGE } from "../constants";

// const downloadFile = (props) => {
//   window.localStorage.setItem("fileDownload.url", props.url);
//   window.localStorage.setItem("fileDownload.text", props.text);
//   // Remove any previously added <a> tags for download
//   let nodeCollection = document.getElementsByClassName("download-placeholder");
//   if (nodeCollection.length > 0) {
//     nodeCollection.item(0).parentNode.removeChild(nodeCollection.item(0));
//   }
//   let myWindow = window.open(
//     Constants.ABSOLUTE_BASE_URL + "/rct#/fileDownload",
//     "_blank"
//   );
// };
// const downloadFile = ({ data, fileName, fileType }) => {
//   const blob = new Blob([data], { type: fileType });

//   const a = document.createElement("a");
//   a.download = fileName;
//   a.href = window.URL.createObjectURL(blob);
//   const clickEvt = new MouseEvent("click", {
//     view: window,
//     bubbles: true,
//     cancelable: true,
//   });
//   a.dispatchEvent(clickEvt);
//   a.remove();
// };

const downloadFile = (data, fileName, sheetName) => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, fileName);
};

const createShowHideText = (text, limit) => {
  text = text || "";
  limit = limit || 30;
  if (text.length > limit) {
    let showText = text.substr(0, limit);
    //console.log(showText)
    return parse(
      "<span>" +
        showText +
        "...</span><a class='show-more-text' id='show-more-text'>[+]</a><span class='hide-data'>" +
        text +
        " <a class='show-less-text'>[-]</a></span>"
    );
  }
  return text;
};

const mergeByProperty = (arr1, arr2, prop) => {
  _.each(arr2, function (arr2obj) {
    var arr1obj = _.find(arr1, function (arr1obj) {
      return arr1obj[prop] === arr2obj[prop];
    });
    //If the object already exist extend it with the new values from arr2, otherwise just add the new object to arr1
    arr1obj ? _.extend(arr1obj, arr2obj) : arr1.push(arr2obj);
  });

  return arr1;
};

const isPublicPage = () => {
  return /.*(\/public\/).*/.test(window.location.href);
};

export const getProjectReqTypeStrToDisplay = (
  requestType,
  parType,
  adoptionPar
) => {
  let displayStr;
  if (requestType === "MODIFY") {
    displayStr = "Modify";
    if (adoptionPar) {
      displayStr = displayStr + " /  New (Adoption)";
    } else if (typeof parType !== "undefined") {
      displayStr = displayStr + " / " + parType;
    }
  } else if (requestType === "PAR_EXTENSION_REQUEST") {
    displayStr = "Extension Request";
    if (adoptionPar) {
      displayStr = displayStr + " /  New (Adoption)";
    } else if (typeof parType !== "undefined") {
      displayStr = displayStr + " / " + parType;
    }
  } else if (requestType === "PAR_WITHDRAWN_BY_SPONSOR") {
    displayStr = "Withdrawal Request";
    if (adoptionPar) {
      displayStr = displayStr + " /  New (Adoption)";
    } else if (typeof parType !== "undefined") {
      displayStr = displayStr + " / " + parType;
    }
  } else if (adoptionPar) {
    displayStr = "Initiation / New (Adoption)";
  } else {
    displayStr = "Initiation / " + parType;
  }
  return displayStr;
};

const displayProjectTypeText = (type) => {
  let displayParString = "";
  if (null !== type) {
    if (type === "New") {
      displayParString = "New IEEE Standard ";
    } else if (type === "Corrigendum") {
      displayParString = "Corrigendum to IEEE Standard ";
    } else if (type === "Amendment") {
      displayParString = "Amendment to IEEE Standard ";
    } else if (type === "Revision") {
      displayParString = "Revision to IEEE Standard ";
    } else if (type === "Adoption") {
      displayParString = "Adoption of a Non-IEEE Standard or Specification ";
    } else if (type === "Modify") {
      displayParString = "Modify Existing Approved PAR ";
    }
    return displayParString;
  }
  return displayParString;
};

// const displayProjectDescription = (parType, baseProjectNumber, stdYear) => {
//   let displayStr = displayProjectTypeText(
//     Lookup.getByCategoryCodeObject("PAR_TYPE", parType).refCodeName
//   );

//   if (parType !== "NEW_PAR" && parType !== "PAR_ADOPTION") {
//     displayStr += baseProjectNumber;
//     if (!_.isUndefined(stdYear) && !_.isNull(stdYear)) {
//       displayStr += "-" + stdYear;
//     }
//   }
//   return displayStr;
// };

// Converts JSON number value to string
const jsonNumberReplacer = (key, value) => {
  if (typeof value === "number") {
    return value.toString();
  }
  return value;
};

const fileTypes = (fileType) => {
  switch (fileType) {
    case "pdf":
      return {
        icon: faFilePdf,
        color: "#d31145",
      };
    case "txt":
      return {
        icon: faFileAlt,
        color: "#000000",
      };
    case "xls":
      return {
        icon: faFileExcel,
        color: "#56b967",
      };
    case "xlsx":
      return {
        icon: faFileExcel,
        color: "#56b967",
      };
    case "doc":
      return {
        icon: faFileWord,
        color: "#009fda",
      };
    case "docx":
      return {
        icon: faFileWord,
        color: "#009fda",
      };
    case "zip":
      return {
        icon: faFileArchive,
        color: "#00000",
      };
    case "csv":
      return {
        icon: faFileCsv,
        color: "#000000",
      };
    default:
      return {
        icon: faPaperclip,
        color: "#333333",
      };
  }
};

const checkForUrls = (stringParam) => {
  const envData = APPConfig.fetchCurrentEnvironment();

  const { myproject } = envData[0];

  if (stringParam === "mypr_url") {
    return myproject;
  }
};

const recursiveParseAllDynamicValues = (tmpobject, allParams) => {
  if (tmpobject !== undefined) {
    //object
    if (typeof tmpobject === "object") {
      //prepopulate any dynamic values inside customFilters with real data if available
      Object.entries(tmpobject).map(([key, value]) => {
        //console.log("loop key ", key, " value ", value, " Object.keys(value).length ", Object.keys(value).length)
        if (typeof value === "object" && Object.keys(value).length > 0) {
          //console.log("looping for object for ", value)
          value = recursiveParseAllDynamicValues(value, allParams);
          //console.log("looping for object complete for ", value)
        }
        //parse the VALUE for %string%
        //e.g. "agendaId": %agendaId%
        if (
          typeof value === "string" &&
          value.startsWith("%", 0) &&
          value.endsWith("%")
        ) {
          try {
            let tmpvar =
              allParams[value.replace(new RegExp("%", "g"), "").toLowerCase()];
            if (tmpvar === undefined) {
              console.error(
                "incorrect input parameter value is not provided for key ",
                key,
                " in customFilters"
              );
              tmpvar = "invalidValue";
            }
            tmpobject[key] = "" + tmpvar;
            //console.log(" updated key ", key, ", with value ", tmpvar)
          } catch (e) {
            console.error("error with value replacement for key ", key, e);
            tmpobject[key] = "invalidValue";
          }
        }
      });
      //for object no need to take this return value
      return tmpobject;
    }
    //string
    if (typeof tmpobject === "string") {
      if (tmpobject.indexOf("%") >= 0) {
        let arrSource = tmpobject.split("%");
        if (arrSource.length > 0) {
          let resposeAr = [];
          arrSource.forEach(function (part, index, theArray) {
            if (typeof allParams[theArray[index]] !== "undefined") {
              //console.log("replacing [", theArray[index], "] with new value [", allParams[theArray[index]], "]")
              resposeAr.push(allParams[theArray[index]]);
            } else if (typeof checkForUrls(theArray[index]) !== "undefined") {
              //find the urls from constant properties
              //console.log("replacing [", theArray[index], "] url")
              resposeAr.push(checkForUrls(theArray[index]));
            } else {
              resposeAr.push(theArray[index]);
            }
          });
          return resposeAr.join("");
        } else {
          //console.log("unable to parse source string")
        }
      } else {
        //console.log("source string contains no parametersr")
      }
      return tmpobject;
    }
  }
};

const voteTypes = (voteType) => {
  switch (voteType) {
    case "YES":
      return {
        color: "#128f5e",
      };
    case "NO":
      return {
        color: "#9e113b",
      };
    default:
      return {
        color: "#000000",
      };
  }
};

export const getCookie = (name = "_e_p_u") => {
  if (document?.cookie) {
    const cookieArray = document.cookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      const cookiePair = cookieArray[i].split("=", 1);
      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookieArray[i]);
      }
    }
  } else {
    return null;
  }
};

export const getToken = () => {
  const cookieValue = getCookie("_e_p_u");
  if (cookieValue?.includes("epjtn")) {
    let getCidValue = "";
    let getUsernameValue = "";
    let getJwtTokenValue = "";
    getCidValue = cookieValue.split("epuc").pop().split("?epuname")[0];
    getUsernameValue = cookieValue.split("epuname").pop().split("?epjtn")[0];
    getJwtTokenValue =
      cookieValue.split("epjtn").pop() +
      "?epucid" +
      getCidValue +
      "?epuname" +
      getUsernameValue;
    return getJwtTokenValue;
  } else {
    window.location.href = SIGNOUTPAGE;

    // return false;
  }
};
export const redirectToLoginPage = () => {
  window.open(LOGINPAGE, "_self", "norefferer");
};
export const redirectToUNAuthrizePage = () => {
  return window.open(UNAUTHRIZEDPAGE, "_self", "norefferer");
};

export default {
  downloadFile,
  createShowHideText,
  mergeByProperty,
  isPublicPage,
  displayProjectTypeText,
  //   displayProjectDescription,
  jsonNumberReplacer,
  fileTypes,
  recursiveParseAllDynamicValues,
  voteTypes,
};
